import { createContext, useContext, useState } from "react";
import { translations } from "./translations.js";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(
    () => localStorage.getItem("ccmc_lang") || "en"
  );

  const changeLang = (next) => {
    setLang(next);
    localStorage.setItem("ccmc_lang", next);
  };

  const toggleLang = () => changeLang(lang === "en" ? "ta" : "en");

  // Translate a key; falls back to English, then the raw key.
  const t = (key) =>
    translations[lang][key] ?? translations.en[key] ?? key;

  return (
    <I18nContext.Provider value={{ lang, t, changeLang, toggleLang }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  return useContext(I18nContext);
}
